import React from "react";
import { Tag } from "antd";
import {
  AiOutlineCheckCircle,
  AiOutlineException,
  AiOutlineExclamationCircle,
  AiOutlineMinusCircle,
  AiOutlineClockCircle,
} from "react-icons/ai";

export function normalizeLeaveStatus(status) {
  if (status == null || status === "") return "";
  return String(status).toUpperCase().replace(/\s+/g, "_");
}

export const LEAVE_WORKFLOW = {
  pending: "PENDING",
  submitted: "SUBMITTED_TO_SUPERVISOR",
  checked: ["SUPERVISOR_APPROVED", "HR_APPROVED"],
  approved: "DIRECTOR_APPROVED",
};

export const isLeaveChecked = (status) =>
  LEAVE_WORKFLOW.checked.includes(normalizeLeaveStatus(status));

export const isLeaveApproved = (status) =>
  normalizeLeaveStatus(status) === LEAVE_WORKFLOW.approved;

export const canModifyLeave = (status) => {
  const s = normalizeLeaveStatus(status);
  return s !== LEAVE_WORKFLOW.approved && s !== "CANCELLED";
};

export function getLeaveApplicationStatusPresentation(status) {
  const normalized = normalizeLeaveStatus(status);

  switch (normalized) {
    case "PENDING":
      return { label: "Pending", color: "warning", icon: AiOutlineExclamationCircle };
    case "SUBMITTED_TO_SUPERVISOR":
      return { label: "Submitted", color: "processing", icon: AiOutlineClockCircle };
    case "SUPERVISOR_APPROVED":
    case "HR_APPROVED":
      return { label: "Checked", color: "processing", icon: AiOutlineMinusCircle };
    case "DIRECTOR_APPROVED":
      return { label: "Approved", color: "success", icon: AiOutlineCheckCircle };
    case "SUPERVISOR_REJECTED":
    case "HR_REJECTED":
    case "DIRECTOR_REJECTED":
      return { label: "Rejected", color: "error", icon: AiOutlineException };
    case "CANCELLED":
      return { label: "Cancelled", color: "default", icon: AiOutlineMinusCircle };
    default:
      return {
        label: normalized ? normalized.replace(/_/g, " ") : "Pending",
        color: "warning",
        icon: AiOutlineExclamationCircle,
      };
  }
}

const LeaveApplicationStatus = ({ status }) => {
  const { label, color, icon: Icon } = getLeaveApplicationStatusPresentation(status);

  return (
    <Tag icon={<Icon />} color={color}>
      <span className="mx-1 text-uppercase">{label}</span>
    </Tag>
  );
};

export default LeaveApplicationStatus;
